import { connect } from 'react-redux';
import { useCallback } from 'react';

import { getPublishRulesActiveTreeItem } from 'PublishRulesPackage/MainModule/selectors/publishRulesSelectors';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import styles from './PublishRulesTreeContent.module.scss';
import { PublishRulesKnmScheduledForm } from './PublishRulesKnmScheduledForm';
import { IPublishRulesTreeItem } from '../interfaces/IPublishRulesTreeItem';
import { PublishRulesKnmUnscheduledForm } from './PublishRulesKnmUnscheduledForm';
import { PublishRulesPmForm } from './PublishRulesPmForm';
import { PublishRulesErpScheduledForm } from './PublishRulesErpScheduledForm';
import { PublishRulesErpUnscheduledForm } from './PublishRulesErpUnscheduledForm';
import { PublishRulesCategoriesEnum } from '../enums/publishRulesCategoriesEnum';
import { PublishRulesDecisionForm } from './PublishRulesDecisionForm';

interface IPublishRulesTreeContentProps {
  activeTreeItem: IPublishRulesTreeItem;
}

const PublishRulesTreeContentWithoutStore = ({ activeTreeItem }: IPublishRulesTreeContentProps) => {
  const renderFormByType = useCallback((category: PublishRulesCategoriesEnum) => {
    const key = `${activeTreeItem.id}_${category}`;

    switch (category) {
      case PublishRulesCategoriesEnum.PLANNED_KNM:
      case PublishRulesCategoriesEnum.PLANNED_KNM_KZ:
      case PublishRulesCategoriesEnum.PLANNED_KNM_RO:
      case PublishRulesCategoriesEnum.PLANNED_KNM_VK:
      case PublishRulesCategoriesEnum.PLANNED_KNM_IV:
      case PublishRulesCategoriesEnum.PLANNED_KNM_MZ:
      case PublishRulesCategoriesEnum.PLANNED_KNM_DP:
      case PublishRulesCategoriesEnum.PLANNED_KNM_VP:
        return <PublishRulesKnmScheduledForm key={key} />;

      case PublishRulesCategoriesEnum.UNPLANNED_KNM:
      case PublishRulesCategoriesEnum.UNPLANNED_KNM_KZ:
      case PublishRulesCategoriesEnum.UNPLANNED_KNM_RO:
      case PublishRulesCategoriesEnum.UNPLANNED_KNM_VK:
      case PublishRulesCategoriesEnum.UNPLANNED_KNM_IV:
      case PublishRulesCategoriesEnum.UNPLANNED_KNM_MZ:
      case PublishRulesCategoriesEnum.UNPLANNED_KNM_DP:
      case PublishRulesCategoriesEnum.UNPLANNED_KNM_VP:
        return <PublishRulesKnmUnscheduledForm key={key} />;

      case PublishRulesCategoriesEnum.PM_PP:
      case PublishRulesCategoriesEnum.PM_OP:
        return <PublishRulesPmForm key={key} />;

      case PublishRulesCategoriesEnum.PLANNED_PM_CHECKS:
      case PublishRulesCategoriesEnum.PLANNED_PM_CHECKS_VP:
      case PublishRulesCategoriesEnum.PLANNED_PM_CHECKS_DP:
      case PublishRulesCategoriesEnum.PLANNED_PM_CHECKS_KZ:
        return <PublishRulesErpScheduledForm key={key} />;

      case PublishRulesCategoriesEnum.UNPLANNED_PM_CHECKS:
      case PublishRulesCategoriesEnum.UNPLANNED_PM_CHECKS_VP:
      case PublishRulesCategoriesEnum.UNPLANNED_PM_CHECKS_DP:
      case PublishRulesCategoriesEnum.UNPLANNED_PM_CHECKS_KZ:
        return <PublishRulesErpUnscheduledForm key={key} />;
      case PublishRulesCategoriesEnum.DECISION_PASSPORT:
        return <PublishRulesDecisionForm key={key} />;
      default:
        <></>;
    }
  }, []);

  return <div className={styles.Wrapper}>{activeTreeItem?.category && renderFormByType(activeTreeItem?.category)}</div>;
};

const mapStateToProps = (state: IRootState) => ({
  activeTreeItem: getPublishRulesActiveTreeItem(state),
});

export const PublishRulesTreeContent = connect(mapStateToProps)(PublishRulesTreeContentWithoutStore);
